import React from 'react';
import { Col, Label, Input, Modal, Button, ModalHeader } from 'reactstrap';

export const ModalPendency = ({ isOpen, toggle, handleSubmit }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggle();
      }}
      zIndex={10000}
      backdrop={'static'}
      id="staticBackdrop"
      centered
    >
      <ModalHeader>Pendência</ModalHeader>
      <div className="modal-body">
        <form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(e);
          }}
        >
          <Col md={12}>
            <div className="mb-3">
              <Label htmlFor="detailsInput" className="form-label">
                Motivo
              </Label>
              <Input
                id="detailsInput"
                aria-multiline
                type="textarea"
                className="form-control"
                style={{
                  height: 100,
                }}
              />
            </div>
          </Col>

          <div className="text-end">
            <button
              className="btn btn-link"
              onClick={() => {
                toggle();
              }}
              type="button"
            >
              {' '}
              Cancelar{' '}
            </button>
            <Button color="primary" type="submit">
              {' '}
              Enviar{' '}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
